import { FaEthereum } from "react-icons/fa"
import { FaBitcoin } from "react-icons/fa"
import { SiXrp } from "react-icons/si"
import { SiDogecoin } from "react-icons/si"

const Hero = () => {
  return (
    <div className="mx-16 lg:mx-36 my-12 lg:my-0">
      <h1 className="head__text" data-aos="fade-right">
        Pay anyone,
      </h1>
      <h2 className="head__text text-[#003049]" data-aos="fade-left">
        anywhere!
      </h2>
      <p className="text-sm md:text-base font-light">
        Pay family, friends and nft's for less - at subsidized gas rates on any
        crypto you own, at one stopping stone.
      </p>
      <div className="flex flex-row items-center text-[2.5rem] text-[#003049] gap-4 mt-3">
        <FaBitcoin data-aos="fade-up-right" />
        <FaEthereum data-aos="fade-up-right" />
        <SiXrp data-aos="fade-up-left" />
        <SiDogecoin data-aos="fade-up-left" />
      </div>
    </div>
  );
};

export default Hero